import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject } from 'rxjs';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { IHasWorkflowPermissions } from '../../../shared/interfaces/has-workflow-permissions.interface';
import { WorkflowPermissionBase } from '../../../shared/models/workflow-permission-base.model';
import { WorkflowEnum } from '../../../shared/enums/workflow.enum';
import { ItemTypeEnum } from '../../../shared/enums/item-type.enum'; 
import { CurrentSiteService } from '../../../shared/services/current-site.service';

// Define a workflow permissions data source, required by the Material table/grid.
export class WorkflowPermissionsDataSource implements DataSource<WorkflowPermissionBase> {
    // Instance data.
    /*
    private workflow: Workflow = null;
    private permissionsType: WorkflowPermissionsType;
    private iStateOrTransitionId: number;
    */
    private hasWorkflowPermissions: IHasWorkflowPermissions = null;

    private permissionsSubject: BehaviorSubject<WorkflowPermissionBase[]> =
        new BehaviorSubject<WorkflowPermissionBase[]>([]);

    // Constructor.
    /*
    public constructor(workflowParam: Workflow,
        permissionsTypeParam: WorkflowPermissionsType,
        iStateOrTransitionIdParam: number) {
    */
    public constructor(hasWorkflowPermissionsParam: IHasWorkflowPermissions) {
        /*
        this.workflow = workflowParam;
        this.permissionsType = permissionsTypeParam;
        this.iStateOrTransitionId = iStateOrTransitionIdParam;
        */
        this.hasWorkflowPermissions = hasWorkflowPermissionsParam;

        return;
    }

    // Getter methods.
    /*
    public get WorkflowPermissionsType(): WorkflowPermissionsType {
        return (this.permissionsType);
    }
    */
    public get PermissionNames(): string[] {
        return (this.hasWorkflowPermissions.getPermissionNames());
    }

    public get SimplePermissionNames(): string[] {
        return (this.hasWorkflowPermissions.getSimplePermissionNames());
    }

    public get HasBuilderPermissions(): boolean {
        let permissionNames: string[] = this.hasWorkflowPermissions.getPermissionNames();
        let arrPermissionName: string[] = permissionNames.filter(pn => pn == 'BuildFolders');

        let bHasPermission: boolean = (arrPermissionName && (arrPermissionName.length > 0));

        return (bHasPermission);
    }

    //VNEXT-439: KLW - Add in logic to only show the suggest permissions button when there are suggested permissions
    public get HasSuggestedPermissions(): boolean {

        let permissions = this.hasWorkflowPermissions.getPermissions();

        let suggestedPermissions = permissions.filter(x =>
            (x.suggestCanEdit == true) ||
            (x.suggestCanView == true) ||
            (x.suggestCanGrant == true) ||
            (x.suggestCanDelete == true) ||
            (x.suggestCanBuildForms == true) ||
            (x.suggestCanBuildWorkflows == true) ||
            (x.suggestCanBuildFolders == true) ||
            (x.suggestCanBuildFormInstances == true) ||
            (x.suggestCanBuildRoles == true)
        );


        let bSuggestedPermissions: boolean = (suggestedPermissions.length > 0);

        return (bSuggestedPermissions);
    }

    //public get IsWorkflowState(): boolean {
    //    let objectType: string = this.hasWorkflowPermissions.constructor.name;

    //    let bIsWorkflowState: boolean = (objectType == 'WorkflowState');

    //    return(bIsWorkflowState);
    //}


    /*
    //public HasPermissionName(permissionNames: string[], permissionName: string): boolean {
    public HasPermissionName(permissionName: string): boolean {
        let permissionNames: string[] = this.hasWorkflowPermissions.getPermissionNames();
        let arrPermissionName: string[] = permissionNames.filter(pn => pn == permissionName);

        let bHasPermission: boolean = (arrPermissionName && (arrPermissionName.length > 0));

        return (bHasPermission);
    }
    */

    // Implement the DataSource interface.
    public connect(collectionViewer: CollectionViewer): Observable<WorkflowPermissionBase[]> {
        let result: Observable<WorkflowPermissionBase[]> = this.permissionsSubject.asObservable();;

        this.permissionsSubject.next(this.hasWorkflowPermissions.getPermissions());

        return (result);
    }

    public disconnect(collectionViewer: CollectionViewer): void {
        this.permissionsSubject.complete();

        return;
    }
    // End implementation the DataSource interface.

    // Manipulate permission records.
    public removePermission(permission: WorkflowPermissionBase): void {
        //let bRemoved: boolean = false;

        this.hasWorkflowPermissions.removePermission(permission);

        this.permissionsSubject.next(this.hasWorkflowPermissions.getPermissions());

        return; // (bRemoved);
    }
}

@Component({
    selector: 'app-workflow-permissions',
    templateUrl: './workflow-permissions.component.html',
    styleUrls: ['./workflow-permissions.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class WorkflowPermissionsComponent implements OnInit, OnDestroy, OnChanges {
    // Properties.
    @Input() hasWorkflowPermissions: IHasWorkflowPermissions;
    @Input() idAndNameObjectType: string = null;
    //VNEXT-441: KLW - Logic to show the correct Workflow action permission name
    @Input() actionName: string = null;

    @Output()
    onClose: EventEmitter<IHasWorkflowPermissions> = new EventEmitter();

    private permissionsDataSource: WorkflowPermissionsDataSource = null;
    private showAnimation: boolean = false;

    // Constructor.
    constructor(public dialog: MatDialog,
                private currentSiteService: CurrentSiteService) {
        return;
    }

    // Life cycle methods.
    ngOnInit(): void {
        if (this.hasWorkflowPermissions) {
            this.permissionsDataSource = new WorkflowPermissionsDataSource(this.hasWorkflowPermissions);
        }

        return;
    }

    ngOnDestroy(): void {
        // Free resources.
        delete this.permissionsDataSource;

        return;
    }

    //VNEXT-392: KLW - Method to dynamically set the animation class
    public showSuggestAnimation(actualPermission: boolean, suggestPermission: boolean): boolean {
        let retVal: boolean = false;

        if (actualPermission == false && suggestPermission == true && this.showAnimation == true)
            retVal = true;

        return retVal;
    }

    public enableClassForSuggest() {
        this.showAnimation = true;
    }

    public disableClassForSuggest() {
        this.showAnimation = false;
    }

    public setSuggestedPermissions() {

        let permissions = this.hasWorkflowPermissions.getPermissions();

        //VNEXT-392: KLW - These will only be set if the role didn't exist beforehand
        permissions.forEach(p => {

            if (p.suggestCanEdit)
                p.canEdit = p.suggestCanEdit;

            if (p.suggestCanView)
                p.canView = p.suggestCanView;

            if (p.suggestCanGrant)
                p.canGrant = p.suggestCanGrant;

            if (p.suggestCanDelete)
                p.canDelete = p.suggestCanDelete;

            if (p.suggestCanBuildForms)
                p.canBuildForms = p.suggestCanBuildForms;

            if (p.suggestCanBuildWorkflows)
                p.canBuildWorkflows = p.suggestCanBuildWorkflows;

            if (p.suggestCanBuildRoles)
                p.canBuildRoles = p.suggestCanBuildRoles;

            if (p.suggestCanBuildFolders)
                p.canBuildFolders = p.suggestCanBuildFolders;

            if (p.suggestCanBuildFormInstances)
                p.canBuildFormInstances = p.suggestCanBuildFormInstances;

            this.hasWorkflowPermissions.updatePermission(p);
        });
    }

    //VNEXT-934: KLW - Hide and show properties when using the simple site permissions
    public get ShowOrHidePropertiesForSimplifiedPermissionsModel(): boolean {
        return this.currentSiteService.Site.useSimplifiedPermissionsModel;
    }

    public get ViewText(): string {
        let retVal: string = "View";

        if (this.currentSiteService.Site.useSimplifiedPermissionsModel) {
            retVal = "View Form";
        }

        return retVal;
    }

    public get EditText(): string {
        let retVal: string = "Edit";

        if (this.currentSiteService.Site.useSimplifiedPermissionsModel) {
            retVal = "Edit Form";
        }

        return retVal;
    }

    public get ActivityListIcon(): string {
        return ItemTypeEnum.ICON;
    }

    public get SuggestButtonDescription() {
        return "The highlighted permissions are the current suggested for the appropiate role. Please click to apply";
    }

    //VNEXT-441: KLW - Logic to show the correct Workflow action permission name
    public get PermissionTitle(): string {
        let retVal: string = "";

        if (this.IsTransition) {
            retVal = this.actionName;
        }
        else {
            if (this.hasWorkflowPermissions.getPermissions().length > 0) {
                retVal = "Permissions";
            }
            else {
                retVal = "Permission";
            }
        }

        return retVal;
    }

    //VNEXT-348: KLW - Get the object types
    public get IsTransition(): boolean {
        return this.idAndNameObjectType == WorkflowEnum.WORKFLOW_ACTION;
    }

    //VNEXT-439: KLW - Add in logic to only show the suggest permissions button when there are suggested permissions
    public get HasSuggestedPermissions(): boolean {
        return this.WorkflowPermissionsDataSource.HasSuggestedPermissions;
    }

    public get IsState(): boolean {
        return this.idAndNameObjectType == WorkflowEnum.WORKFLOW_STATE;
    }

    public get IsWorkflow(): boolean {
        return this.idAndNameObjectType == WorkflowEnum.WORKFLOW;
    }

    // Accessor methods used in my .html file.
    public get Title(): string {
        return (this.hasWorkflowPermissions.getPropertiesTitle());
    }

    public get WorkflowPermissionsDataSource(): WorkflowPermissionsDataSource {
        return (this.permissionsDataSource);
    }

    public get PermissionNames(): string[] {
        let arrPermissionNames: string[] = [];

        if (this.permissionsDataSource !== null) {
            arrPermissionNames = this.permissionsDataSource.PermissionNames;
        }

        return (arrPermissionNames);
    }

    public get SimplePermissionNames(): string[] {
        let arrPermissionNames: string[] = [];

        if (this.permissionsDataSource !== null) {
            arrPermissionNames = this.permissionsDataSource.SimplePermissionNames;
        }

        return (arrPermissionNames);
    }

    public get SimplePermissionName(): string {
        let permissionName: string = null;

        if (this.permissionsDataSource !== null) {
            let arrPermissionNames: string[] = this.permissionsDataSource.SimplePermissionNames;

            if (arrPermissionNames && arrPermissionNames.length > 0) {
                permissionName = arrPermissionNames[0];
            }
        }

        return (permissionName);
    }

    public get PermissionsGridColumnNames(): string[] {
        //VNEXT-348: KLW - Remove the Action column
        let arrColumnNames: string[] = ['Role', 'Permissions'];

        return (arrColumnNames);
    }

    public PermissionsRowExpanded(permission: WorkflowPermissionBase): boolean {
        return (permission.transientIsExpanded);
    }

    public PermissionsExpandedTDClass(permission: WorkflowPermissionBase): string {
        if (permission.transientIsExpanded) {
            if (permission.roleIsSiteAdmin) {
                return 'more-permissions-td-all-options';
            } else {
                return 'more-permissions-td';
            }
        } else {
            return '';
        }
    }

    public PermissionsRowClass(permission: WorkflowPermissionBase): string {
        if (permission.transientIsExpanded) {
            if (permission.roleIsSiteAdmin) {
                return 'displayed-more-permissions-row-all-options';
            } else {
                return 'displayed-more-permissions-row';
            }
        } else {
            return 'displayed-more-permissions-row';
        }
    }

    public MoreLessAnchorTitle(permission: WorkflowPermissionBase): string {
        let anchorTitle: string =
            (permission.transientIsExpanded ? 'Less ...' : 'More ...');

        return (anchorTitle);
    }

    /*
    public MorePermissionsRowStyle(permission: WorkflowPermissionBase): string {
        let style: string = '';

        if (!permission.transientIsExpanded) {
            style = "display: none;";
        }

        return (style);
    }
    */

    // Handle drawer events.
    public drawerClosing(): void {
        return;
    }

    public deletePermission(permission: WorkflowPermissionBase): void {
        //this.hasWorkflowPermissions.removePermission(permission);
        this.permissionsDataSource.removePermission(permission);

        return;
    }

    public transitionPermissionChanged(isTransition: boolean, canView: boolean, permissionsRow: any): void {
        if (isTransition) {
            permissionsRow.canEdit = canView;
        }
    }

    public moreLessPermissionsClicked(event: any, permissionsParam: WorkflowPermissionBase): void {
        // 01-15-2021 note:  I do not like popping up a dialogue
        //                   to capture all of the possible
        //                   permissions for a workflow state,
        //                   so I will probably revisit this at
        //                   some point.

        // Prevent default anchor processing.
        event.preventDefault();
        event.stopPropagation();

        // Expand the permissions row to show all permissions.
        //permissionsParam.transientIsExpanded = true;
        permissionsParam.transientIsExpanded = (!permissionsParam.transientIsExpanded);

        // Open a dialogue with all permissions.
        /*
        let dialogRef = this.dialog.open(PermissionsDialog, {
            width: "400px",
            data: permissionsParam
        });
        dialogRef.afterClosed().subscribe(updatedPermissions => {
            // Copy the updated permissions.
            permissionsParam.copyFieldsFrom(updatedPermissions);
        });
        */

        return;
    }

    public lessPermissionsClicked(event: any, permissionsParam: WorkflowPermissionBase): void {
        // Prevent default anchor processing.
        event.preventDefault();
        event.stopPropagation();

        // Collapse the permissions row to show all permissions.
        permissionsParam.transientIsExpanded = false;

        return;
    }

    /*
    public saveClicked(): void {
        this.onClose.emit();

        return;
    }

    public cancelClicked(): void {
        this.onClose.emit();

        return;
    }
    */

    // Implement the ngOnChanges interface method.
    public ngOnChanges(changes: SimpleChanges): void {
        if ('hasWorkflowPermissions' in changes) {
            this.permissionsDataSource = new WorkflowPermissionsDataSource(this.hasWorkflowPermissions);
        }

        return;
    }

}
